/**
 * Institutional maturity score = mean of station ifipRating values that are > 0.
 * Empty / unset / non-numeric ratings are excluded (same rule as AI draft generation).
 *
 * @param {Record<string, { ifipRating?: string|number|null }>|null|undefined} stationAnalysis
 * @returns {number} Average rounded to 2 decimal places, or 0 if none rated
 */
export function computeOverallMaturityScore(stationAnalysis) {
  const ratings = Object.values(stationAnalysis || {}).map(
    (s) => parseInt(s?.ifipRating, 10) || 0
  );
  const validRatings = ratings.filter((r) => r > 0);
  if (validRatings.length === 0) return 0;
  return parseFloat(
    (validRatings.reduce((a, b) => a + b, 0) / validRatings.length).toFixed(2)
  );
}
